/** Layout / toolbar / preview scaling — keep in sync across TextEditor and menus. */
export const TEXT_EDITOR_MOBILE_LAYOUT_MQ = '(max-width: 767px)';

/** Above .wfm-text-editor--mobile-expanded (1000012) and mention overlay (1000020). */
export const TEXT_EDITOR_MENU_PORTAL_Z_INDEX = 1000022;

export const TEXT_EDITOR_MENU_PORTAL_Z_INDEX_SUBMENU = 1000023;
